const LOAD_LIST_APPLICATIONS           = 'LOAD_LIST_APPLICATIONS'
const LOAD_LIST_APPLICATIONS_SUCCESS   = 'LOAD_LIST_APPLICATIONS_SUCCESS'
const LOAD_LIST_APPLICATIONS_FAILED    = 'LOAD_LIST_APPLICATIONS_FAILED'
const UNMOUNT_LIST_APPLICATIONS        = 'UNMOUNT_LIST_APPLICATIONS'
const initialState = {
  loading: true,
  meta: null,
  data: null,
  message: null,
}
const listApplicationsReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_LIST_APPLICATIONS:
      return {
        ...state,
        loading: true,
        meta: null,
        data: null,
      }
    case LOAD_LIST_APPLICATIONS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        meta: action.payload.meta,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_LIST_APPLICATIONS_FAILED:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_LIST_APPLICATIONS:
      return { 
        ...state, 
        loading: true,
        meta: null,
        data: null,
      }
    default:
      return state
  }
}
export default listApplicationsReducer;